import { forwardRef, useEffect, useMemo, useRef } from 'react';
import gsap from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Text } from '@weareconceptstudio/core';

//* Style
import FaqItemStyle from './style';

//* Components
import Editor from '@/components/Editor';
import TitleAnim from '@/modules/_animation/Title';

gsap.registerPlugin(ScrollTrigger);

const FaqItem = forwardRef(({ data, animRef, isFirst }, ref) => {
	//! Ref
	const triggerRef = useRef();
	const contentRef = useRef();

	const itemData = useMemo(() => {
		return (
			<div
				ref={contentRef}
				className={`wrapper-all-title-wrapper first-all`}
			>
				{data.faqs.map((el, i) => {
					const index = `${data.name}-${i}`;
					return (
						<div key={index}>
							<Text className='h6 font-larken-medium ask-text'>{el.question}</Text>
							<div className='answer-wrapper'>
								<Editor data={el.answer} />
							</div>
							<div className='line' />
						</div>
					);
				})}
			</div>
		);
	}, [data.name, data.faqs]);

	useEffect(() => {
		triggerRef.current = ScrollTrigger.create({
			start: 'top bottom',
			end: 'top top',
			trigger: animRef.current,
			onEnter: () => {
				if (contentRef.current?.children?.length) {
					gsap.fromTo(contentRef.current.children, { opacity: 0 }, { opacity: 1, ease: 'power2.in', duration: 0.4, stagger: 0.1, delay: 0.3 });
				}
			},
			onLeaveBack: () => {
				if (contentRef.current?.children?.length) {
					gsap.set(contentRef.current.children, { opacity: 0 });
				}
			},
		});

		return () => {
			if (triggerRef.current) {
				triggerRef.current.kill();
			}
		};
	}, [animRef, data.faqs]);

	return (
		<FaqItemStyle
			ref={ref}
			className='faq-item-block'
		>
			{isFirst ? (
				<TitleAnim
					className={'title-anim'}
					animRef={animRef}
					load={true}
					delayAnim={200}
				>
					<Text className='h3 font-larken-light wrapper-categories-title first-letter'>{data.name}</Text>
				</TitleAnim>
			) : (
				<Text className='h3 font-larken-light wrapper-categories-title first-letter'>{data.name}</Text>
			)}

			{itemData}
		</FaqItemStyle>
	);
});

FaqItem.displayName = 'FaqItem';

export default FaqItem;
